import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StepProgressService {
	private stepData: any;

	constructor() {
		// All'avvio, carica i progressi salvati dal localStorage, oppure inizializza quelli di default
		const saved = localStorage.getItem('step-progress');
		this.stepData = saved ? JSON.parse(saved) : this.initDefaultData();
	}

	// Definisce la struttura iniziale dei percorsi e dei relativi step
	private initDefaultData() {
		return {
			'steps-verifica': {
				order: ['step-uno', 'step-due', 'step-tre', 'step-quattro'],
				completed: [],
			},
			'steps-preventivo': {
				order: ['step-uno', 'step-due', 'step-tre'],
				completed: [],
			},
		};
	}

	// Salva lo stato corrente nel localStorage
	private saveToStorage() {
		localStorage.setItem('step-progress', JSON.stringify(this.stepData));
	}

	/**
	 * Segna uno step come completato per una determinata sezione (es. 'steps-verifica')
	 * Aggiunge lo step all'array solo se non è già presente, poi salva su localStorage
	 */
	markStepCompleted(section: string, step: string): void {
		const data = this.stepData[section];
		if (!data) return;

		if (!data.completed.includes(step)) {
			data.completed.push(step);
			this.saveToStorage();
		}
	}

	/**
	 * Verifica se un determinato step è accessibile:
	 * - Il primo step è sempre accessibile
	 * - Gli altri sono accessibili solo se il precedente è stato completato
	 */
	isStepAllowed(section: string, step: string): boolean {
		const data = this.stepData[section];
		if (!data) return false;

		const index = data.order.indexOf(step);
		if (index === -1) return false; // step non trovato

		if (index === 0) return true; // primo step sempre accessibile

		const previousStep = data.order[index - 1];
		return data.completed.includes(previousStep);
	}

	/**
	 * Verifica se uno step specifico è stato completato
	 */
	isStepCompleted(section: string, step: string): boolean {
		return this.stepData[section]?.completed.includes(step) || false;
	}

	/**
	 * Resetta gli step completati per una determinata sezione
	 */
	reset(section: string): void {
		if (this.stepData[section]) {
			this.stepData[section].completed = [];
			this.saveToStorage();
		}
	}

	/**
	 * Recupera l'ultimo step completato per una sezione
	 * Restituisce l'ultimo step della lista di completamenti
	 */
	getLastCompletedStep(section: string): string {
		const data = this.stepData[section];
		if (!data || data.completed.length === 0) return ''; // Nessun step completato

		return data.completed[data.completed.length - 1];
	}

	/**
	 * Recupera il prossimo step da completare (se disponibile)
	 * Restituisce il prossimo step da eseguire in base alla sequenza
	 */
	getNextStep(section: string, currentStep: string): string {
		const data = this.stepData[section];
		if (!data) return '';

		const currentIndex = data.order.indexOf(currentStep);
		if (currentIndex === -1 || currentIndex === data.order.length - 1) return ''; // Se non trovato o è l'ultimo step

		return data.order[currentIndex + 1]; // Passo successivo
	}
}
